import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, Injector, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { isWalletPassServiceRequest } from "../wallet-request.util";

/**
 * Forwards the admin UI language to wallet-pass so preview reasons/summary are localized.
 *
 * TranslateService is resolved lazily via Injector to avoid NG0200 circular DI:
 * TranslateHttpLoader → HttpClient → HTTP_INTERCEPTORS → TranslateService → …
 */
@Injectable({ providedIn: "root" })
export class WalletPassLanguageInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!isWalletPassServiceRequest(req.url)) {
      return next.handle(req);
    }

    const translate = this.injector.get(TranslateService);
    const lang = (translate.currentLang || translate.defaultLang || "en").slice(0, 2);
    return next.handle(req.clone({ setHeaders: { "Accept-Language": lang } }));
  }
}
